(function() {
  // Protection contre double init
  if (window.klaviyoGoalsTracking) return;
  window.klaviyoGoalsTracking = true;
  
  let selectedTrainingGoal = '';
  
  // Mapping FR/EN
  const goalMapping = {
    'Meilleure hydratation': 'Better hydration',
    'Energie propre et stable': 'Clean steady energy',
    'Evite les crampes sous la chaleur': 'Beat cramps in heat',
    'Récupération rapide': 'Recover faster',
    'Better hydration': 'Better hydration',
    'Clean steady energy': 'Clean steady energy',
    'Beat cramps in heat': 'Beat cramps in heat',
    'Recover faster': 'Recover faster'
  };
  
  // Capturer TOUS les clics sur les boutons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button');
    if (!button) return;
    
    const buttonText = button.textContent.trim();
    if (goalMapping[buttonText]) {
      selectedTrainingGoal = goalMapping[buttonText];
      console.log('🎯 Training goal selected:', selectedTrainingGoal);
      sessionStorage.setItem('klaviyo_goal', selectedTrainingGoal);
    }
  });
  
  // Intercepter la soumission
  document.addEventListener('submit', function(e) {
    const form = e.target;
    const emailInput = form.querySelector('input[type="email"]');
    
    if (emailInput && selectedTrainingGoal) {
      console.log('📧 Form submitted with goal:', selectedTrainingGoal);
      
      // Ajouter le champ caché
      let hiddenField = form.querySelector('input[name="Training goals"]');
      if (!hiddenField) {
        hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'Training goals';
        form.appendChild(hiddenField);
      }
      hiddenField.value = selectedTrainingGoal;
      
      // API Klaviyo
      if (window._klOnsite && emailInput.value) {
        setTimeout(() => {
          window._klOnsite.push(['identify', {
            '$email': emailInput.value,
            'Training goals': selectedTrainingGoal
          }]);
          console.log('✅ Klaviyo identify sent');
        }, 100);
      }
    }
  }, true);
})();